import React, { useEffect } from 'react';
import { Dialog } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { Page } from '../layout';
import { useSearchParams } from 'react-router-dom';
import { useClientSessionOmitter } from '@shared/hooks/useClientSessionOmitter';

const IS_RELOAD_STORAGE_ITEM = 'isReload';

export const LoggedOutWarningPage = () => {
  const pageTitle = 'Session Ended';

  const [searchParams] = useSearchParams();
  const isReasonAnotherDevice = searchParams.get('reason') == 'ANOTHERDEVICE';
  const isReload = localStorage.getItem(IS_RELOAD_STORAGE_ITEM);

  const { endCMMISession } = useClientSessionOmitter();

  useEffect(() => {
    localStorage.setItem(IS_RELOAD_STORAGE_ITEM, 'true');
  }, []);

  if (!isReasonAnotherDevice || isReload) {
    endCMMISession();
    return null;
  }

  return (
    <Page title={pageTitle}>
      <Dialog open={true} maxWidth='md' fullWidth onClose={endCMMISession}>
        <div className='logged-out-warning-modal'>
          <button
            data-testid='close-button'
            className='logged-out-warning-modal__close'
            onClick={endCMMISession}>
            <CloseIcon />
          </button>
          <div className='logged-out-warning-modal__content'>
            <h2>You have been logged out due to an active session on another device.</h2>
          </div>
        </div>
      </Dialog>
    </Page>
  );
};

export default LoggedOutWarningPage;
